import { useMemo } from 'react';
import useExperiment from "./useExperiment";
import isServer from "../utils/isServer";

function useCoinPricingExperiment() {
  const state = useExperiment('coin-package-test-v6');
  const listName = useMemo(() => !state.loading ? state.election?.name || 'default' : null, [state]);
  // set core cookie to solve buy coins refresh issue where buy coins shows
  if (listName && !isServer()) {
    setCookie('coin_package_list_name_v6', listName, 28);
  }
  return listName;
}

function setCookie(name: string, value: string, days: number) {
  let expires;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  } else {
    expires = "";
  }
  document.cookie = name+"="+value+expires+"; path=/";
}

export default useCoinPricingExperiment;
